import { useState } from "react";
import { deleteCnoLine, deleteCnoPatient } from "../../../services/api";
import {
    dropStatuses,
    patientStatusKeys,
    removeLine,
    removePatient,
    saveKeyForLine,
    saveKeyForPatient,
} from "../model/cnoRules";

// Suppressions confirmées d'un patient ou d'un produit CNO.
export default function useCnoDeletions(cno) {
    const { selectedPatient, setPatients, setSaveStatuses, setSaveError, markStatus } = cno;
    const [lineToDelete, setLineToDelete] = useState(null);
    const [deletingLine, setDeletingLine] = useState(false);
    const [patientToDelete, setPatientToDelete] = useState(null);
    const [deletingPatient, setDeletingPatient] = useState(false);

    const confirmDeletePatient = async () => {
        if (!patientToDelete) return;
        const patientId = patientToDelete.id;
        setDeletingPatient(true);
        setSaveError("");
        try {
            if (typeof patientId === "number") {
                await deleteCnoPatient(patientId);
            }
            setPatients(current => removePatient(current, patientId));
            setSaveStatuses(current => dropStatuses(current, patientStatusKeys(patientToDelete)));
            setPatientToDelete(null);
        } catch {
            markStatus(saveKeyForPatient(patientId), "error");
            setSaveError("Le patient CNO n'a pas pu être supprimé en base.");
        } finally {
            setDeletingPatient(false);
        }
    };

    const confirmDeleteCno = async () => {
        if (!lineToDelete || !selectedPatient) return;
        const patientId = selectedPatient.id;
        const lineId = lineToDelete.id;
        const deleteKey = lineToDelete.clientId || lineId;
        const statusKey = saveKeyForLine(deleteKey);
        setDeletingLine(true);
        setSaveError("");
        try {
            if (typeof patientId === "number" && typeof lineId === "number") {
                await deleteCnoLine(patientId, lineId);
            }
            setPatients(current => removeLine(current, patientId, deleteKey));
            setSaveStatuses(current => dropStatuses(current, [statusKey]));
            setLineToDelete(null);
        } catch {
            markStatus(statusKey, "error");
            setSaveError("Le produit CNO n'a pas pu être supprimé en base.");
        } finally {
            setDeletingLine(false);
        }
    };

    return {
        lineToDelete, setLineToDelete, deletingLine, confirmDeleteCno,
        patientToDelete, setPatientToDelete, deletingPatient, confirmDeletePatient,
    };
}
